/* eslint-disable newline-per-chained-call */
import { isBefore, startOfDay } from 'date-fns';
import { z } from 'zod';

const requestHoldingServiceFormSchema = z.object({
    services: z
        .array(z.number().int().positive().gt(0))
        .min(1, 'Must request to hold at least one service'),

    reasonNote: z.string({
        required_error: 'Reason is required',
    }).min(1, 'Reason cannot be empty'),
    holdDate: z
        .date({
            required_error: 'Date is required',
            invalid_type_error: 'Date is required',
        })
        .refine(
            (date) => !isBefore(startOfDay(date), startOfDay(new Date())),
            () => ({
                message: 'Date cannot be in the past',
            })
        ),
});

type RequestHoldingServiceFormFormValues = z.infer<
    typeof requestHoldingServiceFormSchema
>;

export { requestHoldingServiceFormSchema, RequestHoldingServiceFormFormValues };
